import { transition } from "@angular/animations";

export class GlobalContants {
    static Routes = class {
        public static get LogIn(): string {
            return '';
        }
        public static get Home(): string {
            return 'home';
        }
        public static get authentication(): string {
            return 'authentication'
        }
        public static get Log_In(): string {
            return 'login';
        }
        public static get ForgotPassword(): string {
            return 'forgot-password';
        }
        public static get Dashboard(): string {
            return 'dashboard';
        }
        public static get Profile(): string {
            return 'profile';
        }
        public static get ChangePassword(): string {
            return 'change-password';
        }
        public static get GenerateApiKey(): string {
            return 'generate-api-key'
        }
        public static get AvmGgroup(): string {
            return 'avm-group'
        }
        public static get NearbyGroup(): string {
            return 'nearby-group'
        }
        public static get AvmRental(): string {
            return 'avm-rental'
        }
        public static get AuthenticationAPI(): string {
            return 'authentication-api'
        }
        public static get ApiTest(): string {
            return 'api-test'
        }
        public static get CommercialData(): string {
            return 'commercial-data'
        }
        public static get CommercialRental(): string {
            return 'commercial-rental'
        }
        public static get ApartmentSaleAVM(): string {
            return 'apartment-sale-avm'
        }
        public static get Buildings(): string {
            return 'buildings'
        }
        public static get Floor(): string {
            return 'floor'
        }
        public static get Unit(): string {
            return 'unit'
        }
        public static get Transaction(): string {
            return 'transaction'
        }
        public static get AvmApi(): string {
            return 'avm-api'
        }
         public static get nearbbyApi(): string {
            return 'nearbyapi'
        }
         public static get avmCalculator(): string {
            return 'avm-calculator'
        }
    }


    static StoreKey = class {

        public static get userInfo(): string {
            return 'user_info';
        }
        public static get userToken(): string {
            return 'user_token';
        }
    }

    static defaultTitleConstant = class {
        public static get defaultTitle(): string {
            return 'Estater API'
        }
    }

}

export const PageTitle = {
    "dashboard": "Dashboard",
    "authentication": "Authentication",
    "login": "Login",
    "forgotPassword": "Forgot Password",
    "profile": "Profile",
    "changePassword": "Change Password",
    "generateApiKey": "Generate Api Key",
    "avmGroup": "Avm Data",
    "nearbyGroup": "Nearby Data",
    "avmRental": "Avm Rental",
    "avmApi": "Avm API",
    "authenticationApi": "Authentication Api",
    "apiTest": "Api Test",
    "commercialData": "Commercial Data",
    "commercialRental": "Commercial Rental",
    "apartmentSaleAVM": "Apartment Sale",
    "buildings": "Buildings",
    "floor": "Floor",
    "unit": "Unit",
    "transaction": "Transaction",
    "nearbyApi":"Nearby Amenities",
    "avmCalculator":"Avm Calculator"
}

export const Resource = {
    AvmData: "avm_data",
    AvmApi: "avm",
    NearbyData: "nearby_data",
    OfficeProperty: "office_property",
    AvmRental: "avm_rental",
    CommercialRental: "commercial_rental",
    Building: "building",
    Floor: "floor",
    Unit: "unit",
    Transaction: "transaction",
    nearby:"nearby",
    avmCalculator:"avm_calculator"
}